import React from 'react';
import SystemLogsSection from '../../../sections/AdminDashboard/Settings/SystemLogs';

const SystemLogs = () => {
  return <SystemLogsSection />;
};

export default SystemLogs;
